import { useEffect, useRef, useState } from '@wordpress/element';
import styles from './Tabs.module.css';

const DropdownTab = ({ tab, isActive, onTabClick, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleItemClick = (tabId) => {
    onTabClick(tabId);
    // Don't close dropdown when clicking items inside it
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={styles['hvnly-settings-api__dropdown-tab']} ref={dropdownRef}>
      <button
        type="button"
        className={`${styles['hvnly-settings-api__tab']} ${isActive ? styles['hvnly-settings-api__tab--active'] : ''} ${styles['hvnly-settings-api__dropdown-tab-toggle']}`}
        onClick={handleToggle}
      >
        <i className={tab.icon}></i> 
        <span>{tab.label}</span>
        {tab.badge && (
          <span className={styles['hvnly-settings-api__tab-badge']}>{tab.badge}</span>
        )}
        <i className={`fas fa-chevron-down ${styles['hvnly-settings-api__dropdown-chevron']} ${isOpen ? styles['hvnly-settings-api__dropdown-chevron--open'] : ''}`}></i>
      </button>
      
      {isOpen && (
        <div className={styles['hvnly-settings-api__dropdown-menu']}>
          {children(handleItemClick)}
        </div>
      )}
    </div>
  );
};

export default DropdownTab;